<template>
  <div
    class="slider-wrapper"
    ref="wrapper"
    @touchstart="handlerStart"
    @mouseup="handlerStart"
    @touchmove="handlerMove"
    @mousemove="handlerMove"
    @touchend="handlerEnd"
    @mousedown="handlerEnd"
  >
    <div class="tab-container bg-FFFFFF">
      <md-tabbar
        v-model="currentTabIndex"
        :indicatorColor="tabBottomBg"
        class="bb"
      >
        <md-tabbar-item v-for="item in tabList" :key="item.id" :name="item.id">
          <span>{{ item.name }}</span>
          <md-badge
            v-if="+item.badge"
            class="ml-4"
            :content="item.badge"
            color="danger"
            circle
          ></md-badge>
        </md-tabbar-item>
      </md-tabbar>
    </div>
    <common-swiper
      class="my-slider swiper-no-swiping"
      :initialSlide="activeTabIndex - 1"
      ref="myTabSwiper"
    >
      <div
        slot="content"
        class="page-view"
        v-for="(item, index) in tabList"
        :key="`view-${item.id}`"
        :style="computedStyle"
      >
        <div
          v-if="item.tagList && item.tagList.length"
          class="tag-view nowrap scroll-x bg-FFFFFF"
        >
          <div
            v-for="(tag, idx) in item.tagList"
            @click="handlerChangeTag(tag, idx)"
            :key="`tag${idx}`"
            class="font-28 text-center inline-block ff-regular text-bold-400 mr-16 bd-radio-9999"
            :class="
              currentTagIndex === idx + 1
                ? 'bg-006AFE c-FFFFFF'
                : 'bg-191F25-8 c-171A1D-40'
            "
            >{{ tag.tagName }}</div
          >
        </div>
        <div
          class="tab-content scroll-y"
          :ref="`tab-${index}`"
          @scroll="handlerToGetNext"
          :style="`height:${
            scrollHeight - 48 - (item.tagList && item.tagList.length ? 44 : 0)
          }px`"
        >
          <slot :name="`tab-content-${index}`" class="height-full"></slot>
        </div>
      </div>
    </common-swiper>
    <!-- TODO 优化动画交互 -->
    <div class="refresh-icon" :style="refreshStyle">
      <img src="@/assets/images/icon_update.png" />
    </div>
  </div>
</template>

<script>
import commonSwiper from './commonSwiper'
import { debounce } from '@/utils/comUtils'
const refreshDistance = 50 // 触发下拉刷新的阈值
const refreshMaxDistance = 80
export default {
  components: {
    commonSwiper
  },
  props: {
    tabBottomBg: {
      type: String,
      default: '#171A1D'
    },
    tabList: {
      type: Array,
      default() {
        return []
      }
    },
    activeTabIndex: {
      type: [Number, String],
      default: 0
    },
    activeTagIndex: {
      type: [Number, String],
      default: 0
    },
    scrollHeight: {
      type: [Number, String],
      default: 0
    },
    allowRefresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentTabIndex: this.activeTabIndex || 1,
      currentTagIndex: this.activeTagIndex || 1,
      start: { x: 0, y: 0 },
      curRefreshDistance: 0,
      isRefresh: false
    }
  },
  computed: {
    computedStyle() {
      return {
        width: `${document.body.clientWidth}px`
      }
    },
    refreshStyle() {
      if (this.curRefreshDistance <= 0) return
      let percent = this.curRefreshDistance / refreshMaxDistance
      return {
        top: this.curRefreshDistance + 'px',
        opacity: percent,
        transform: `rotate(${360 * percent}deg)`,
        '-webkit-transform': `rotate(${360 * percent}deg)`
      }
    }
  },
  watch: {
    activeTagIndex(val) {
      this.currentTagIndex = val
    },
    activeTabIndex(val) {
      this.currentTabIndex = val
    },
    currentTabIndex(val) {
      const index = this.tabList.findIndex(item => item.id === val)
      this.handlerChangeTab(this.tabList[index], index)
    }
  },
  mounted() {},
  methods: {
    handlerStart(evt) {
      if (!this.allowRefresh) return
      evt = evt.changedTouches ? evt.changedTouches[0] : evt
      this.isRefresh = true
      this.start.x = evt.pageX
      this.start.y = evt.pageY
    },
    handlerMove(evt) {
      if (!this.isRefresh) return
      const e = evt.changedTouches ? evt.changedTouches[0] : evt

      const offsetTop = e.pageY - this.start.y
      if (offsetTop < refreshDistance) {
        if (this.curRefreshDistance) {
          this.curRefreshDistance = Math.min(offsetTop, refreshDistance)
        }
        return
      }

      this.curRefreshDistance = Math.min(offsetTop, refreshMaxDistance)
      evt.preventDefault()
    },
    handlerEnd() {
      if (!this.isRefresh) return

      if (this.curRefreshDistance >= refreshMaxDistance) {
        this.$emit('pullRefresh', this.activeTabIndex)
      }
      this.isRefresh = false
      this.curRefreshDistance = 0
    },

    handlerChangeTab(item, index) {
      this.$refs.myTabSwiper.slideTo(item.id - 1)
      this.$refs[`tab-${this.currentTabIndex - 1}`][0].scrollTo(0, 0)
      debounce(this.hanlderSlideChange, 200)({ realIndex: item.id - 1, index })
    },
    hanlderSlideChange({ realIndex = 0, index } = {}) {
      this.currentTabIndex = realIndex + 1
      this.$emit('change', realIndex + 1, index)
    },
    handlerToGetNext(e) {
      let _el = e.currentTarget
      if (_el.scrollTop + _el.clientHeight >= _el.scrollHeight - 10) {
        this.$emit('next-page')
      }
    },
    handlerChangeTag(tag, idx) {
      this.currentTagIndex = idx + 1
      this.$refs[`tab-${this.currentTabIndex - 1}`][0].scrollTo(0, 0)
      debounce(this.changeTagEmitter, 200)(tag, idx)
    },
    changeTagEmitter(tag, idx) {
      this.$emit('change-tag', {
        tag: tag,
        activeTabIndex: this.currentTabIndex,
        activeTagIndex: idx + 1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-wrapper {
  .tab-container {
    :deep( .md-badge-container .md-danger-color) {
      background-color: #ff5219;
    }
    .tab-bottom {
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -12px;
      width: 24px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
  .my-slider {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    .tag-view {
      padding: 9px 0px 9px 16px;
      > div {
        padding: 4px 12px;
      }
    }
  }
  .lateList {
    background: #fff;
    > div {
      height: 56px;
    }
    &:last-child {
      .st-con {
        border-bottom: none;
      }
    }
  }
  .scroll-x {
    overflow-x: scroll;
  }
  .refresh-icon {
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    top: 0;
    opacity: 0;
    transform: rotate(0);
    z-index: 100;
    transition: all 0.3s;
  }
}
</style>
